"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _organizations = require("@/api/organizations");
var _ga = require("@/utils/ga");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OragnizatioinDetail',
  props: {
    displayType: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      existingEmailDomains: {},
      fullscreenloading: false,
      createButtonDisable: false,
      showThumbnailUploadErrMsg: false,
      tagInputValue: '',
      /* for tags component user */
      tagInputVisible: false,
      /* for tags component user */
      file: null,
      organizationForm: {
        id: '',
        name: '',
        emailDomains: [],
        logo: {
          url: ""
        }
      }
    };
  },
  created() {
    this.getList();
    if (this.displayType === 'edit') {
      this.getOrganization();
    }
  },
  methods: {
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _organizations.getAllOrganizations)(token).then(response => {
        const currentOrgId = this.$route.params.id;
        const organizations = response.data.rows;
        const domainToOrgName = {};
        organizations.forEach(org => {
          if (currentOrgId !== org.id) {
            // Only add domains for organizations that are not the current one
            (org.emailDomains || []).forEach(domain => {
              domainToOrgName[domain.toLowerCase()] = org.name;
            });
          }
        });
        this.existingEmailDomains = domainToOrgName;
      }).catch(error => {
        (0, _log.showDebugLog)('getAllOrganizations-api-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    },
    doAddSave() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      if (this.organizationForm.name === "") {
        this.fullscreenloading = false;
        const msg = "Organization's Name is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.organizationForm.name.length > 100) {
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)("Organization's Name max length is 100", "error");
        return;
      }
      this.fullscreenloading = true;
      const payload = {
        name: this.organizationForm.name,
        emailDomains: this.organizationForm.emailDomains
      };
      (0, _organizations.createOrganization)(token, payload).then(response => {
        const data = response.data || {};
        const logo = data.logo || {};
        this.organizationForm = {
          id: data.id || '',
          name: data.name || '',
          emailDomains: data.emailDomains || [],
          logo: {
            url: logo.url || '' // 安全访问
          }
        };
        this.createButtonDisable = true;
        this.fullscreenloading = false;
        const msg = `${response.data.name} (${response.data.id}) is created.`;
        (0, _log.displayPopupMessage)(msg, 'success');
        (0, _ga.writeGaEvent)(this, 'Create Oragization', "Create Oragization", oEmail, `Oragization ID: ${this.organizationForm.id}`);
        // Close current tab first
        this.$store.dispatch('tagsView/delView', this.$route).then(() => {
          // Then navigate to the new page
          this.$router.push(`/organizations/edit/${response.data.id}`);
        });
      }).catch(error => {
        (0, _log.showDebugLog)('Oragization-createOragization-API-error', error);
        this.fullscreenloading = false;

        // 檢查是否是我們知道的API錯誤結構
        if (error.response && error.response.data && error.response.data.message) {
          // 只顯示API返回的message
          (0, _log.displayPopupMessage)(error.response.data.message, 'error');
        } else {
          // 其他網絡錯誤保持原樣
          (0, _log.displayPopupMessage)(error, 'error');
        }
      });
    },
    doSave() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      const id = typeof this.$route.params.id === 'undefined' ? this.organizationForm.id : this.$route.params.id;
      if (this.organizationForm.name === "") {
        this.fullscreenloading = false;
        const msg = "Organization's Name is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.organizationForm.name.length > 100) {
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)("Organization's Name max length is 100", "error");
        return;
      }
      this.fullscreenloading = true;
      const payload = {
        name: this.organizationForm.name,
        emailDomains: this.organizationForm.emailDomains
      };
      const logo = this.organizationForm.logo || {};
      if (logo && logo.url) {
        delete logo.url;
        payload.logo = logo;
      }
      (0, _organizations.updateOrganizationById)(token, id, payload).then(response => {
        const data = response.data || {};
        const logo = data.logo || {};
        this.organizationForm = {
          id: data.id || '',
          name: data.name || '',
          emailDomains: data.emailDomains || [],
          logo: logo
        };
        const msg = `${response.data.name} (${response.data.id}) is updated.`;
        (0, _log.displayPopupMessage)(msg, 'success');
        (0, _ga.writeGaEvent)(this, 'Edit Oragization', "Edit Oragization", oEmail, `Oragization ID: ${this.organizationForm.id}`);
        this.fullscreenloading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('Oragization-updateOrganizationById-API-Error', error);
        this.fullscreenloading = false;
        // 檢查是否是我們知道的API錯誤結構
        if (error.response && error.response.data && error.response.data.message) {
          // 只顯示API返回的message
          (0, _log.displayPopupMessage)(error.response.data.message, 'error');
        } else {
          // 其他網絡錯誤保持原樣
          (0, _log.displayPopupMessage)(error, 'error');
        }
      });
    },
    doThumbnailUpload() {
      (0, _log.showDebugLog)('Debug-uploadLogoFile', this.thumbnailFile);
      this.fullscreenloading = true;
      const thumbnailIconForm = new FormData();
      thumbnailIconForm.append('file', this.thumbnailFile);
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _organizations.uploadFile)(token, this.organizationForm.id, thumbnailIconForm).then(response => {
        this.fullscreenloading = false;
        this.showThumbnailUploadErrMsg = false;
        const data = response.data || {};
        this.organizationForm.logo = data || {};
      }).catch(error => {
        (0, _log.showDebugLog)('upload-organizatioin-logo-api-error', error);
        this.fullscreenloading = false;
        this.showThumbnailUploadErrMsg = true;
      });
    },
    chooseThumbnailFile(e) {
      if (e.target.files.length > 0) {
        (0, _log.showDebugLog)('Debug-uploadTrainingImg', e.target.files[0]);
        if (e.target.files[0].size <= 5 * 1024 * 1024) {
          this.thumbnailFile = e.target.files[0];
        } else {
          (0, _log.displayPopupMessage)('Image size should not be exceeded 5M', 'error');
          this.$refs.thumbfile.value = '';
        }
      }
    },
    getOrganization() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const id = typeof this.$route.params.id === 'undefined' ? this.organizationForm.id : this.$route.params.id;
      this.fullscreenloading = true;
      (0, _organizations.getOrganizationById)(token, id).then(response => {
        this.fullscreenloading = false;
        (0, _log.showDebugLog)('getOrganizationId-API', response.data);
        const data = response.data || {};
        const logo = data.logo || {};
        this.organizationForm = {
          id: data.id || '',
          name: data.name || '',
          emailDomains: data.emailDomains || [],
          logo: logo
        };
      }).catch(error => {
        (0, _log.showDebugLog)('Organization-GetOrganizationId-API-Error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    /* for tag component use */
    handleClose(tag) {
      this.organizationForm.emailDomains.splice(this.organizationForm.emailDomains.indexOf(tag), 1);
    },
    handleTagInputConfirm() {
      const inputValue = this.tagInputValue;

      // Check if inputValue is a valid email domain (simple regex)
      const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (inputValue && domainRegex.test(inputValue) && this.organizationForm.emailDomains.indexOf(inputValue) < 0) {
        // Check if the domain already exists in the existingEmailDomains
        if (this.existingEmailDomains[inputValue.toLowerCase()]) {
          (0, _log.displayPopupMessage)('This email domain already used in the organization "' + this.existingEmailDomains[inputValue.toLowerCase()] + '".', 'error');
        } else {
          this.organizationForm.emailDomains.push(inputValue.toLowerCase());
        }
      } else if (inputValue && !domainRegex.test(inputValue)) {
        (0, _log.displayPopupMessage)('Please enter a valid email domain.', 'error');
      }
      this.tagInputVisible = false;
      this.tagInputValue = '';
    },
    showTagInput() {
      this.tagInputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    }
  }
};